/** Kategorije vježbi iz `exerciseInput` → i18n ključevi portala. */
export const CATEGORY_KEY: Record<string, string> = {
  chest: 'exerciseLib.catChest',
  back: 'exerciseLib.catBack',
  shoulders: 'exerciseLib.catShoulders',
  arms: 'exerciseLib.catArms',
  legs: 'exerciseLib.catLegs',
  glutes: 'exerciseLib.catGlutes',
  core: 'exerciseLib.catCore',
  cardio: 'exerciseLib.catCardio',
  mobility: 'exerciseLib.catMobility',
  full_body: 'exerciseLib.catFullBody',
};

export const CATEGORIES = Object.keys(CATEGORY_KEY);

export const DIFFICULTY_KEY: Record<string, string> = {
  beginner: 'exerciseLib.difficultyBeginner',
  intermediate: 'exerciseLib.difficultyIntermediate',
  advanced: 'exerciseLib.difficultyAdvanced',
};

export const WORKOUT_TYPE_KEY: Record<string, string> = {
  strength: 'builder.typeStrength',
  cardio: 'builder.typeCardio',
  mobility: 'builder.typeMobility',
  rest: 'builder.typeRest',
  mixed: 'builder.typeMixed',
};
